import instance from "./index";

const normalizeSkill = (skill) => ({
  ...skill,
  skillId:
    skill?.skillId ??
    skill?.SkillId ??
    skill?.id ??
    skill?.Id ??
    null,
  skillName:
    skill?.skillName ??
    skill?.SkillName ??
    skill?.name ??
    "",
  statusId: skill?.statusId ?? skill?.StatusId ?? null,
});

const extractList = (data) =>
  Array.isArray(data) ? data : Array.isArray(data?.data) ? data.data : [];

export const getAllSkills = async () => {
  try {
    const response = await instance.get("/skills/getAll");
    return extractList(response?.data).map(normalizeSkill);
  } catch (error) {
    const message =
      error?.response?.data?.message ||
      error?.response?.data?.detail ||
      error?.message ||
      "Failed to load skills";
    throw new Error(message);
  }
};

export const createSkill = async ({ skillName }) => {
  const trimmed = String(skillName ?? "").trim();
  if (!trimmed) throw new Error("Skill name is required");

  try {
    const response = await instance.post("/skills", { skillName: trimmed });
    const data = response?.data?.data ?? response?.data ?? {};
    return normalizeSkill({ ...data, skillName: data.skillName ?? trimmed });
  } catch (error) {
    const message =
      error?.response?.data?.message ||
      error?.response?.data?.detail ||
      error?.message ||
      "Failed to create skill";
    throw new Error(message);
  }
};
